import router, { resetRouter } from './router';
import store from './store';
import storage from 'store';
import NProgress from 'nprogress';
import '@/components/NProgress/nprogress.less';
import { setDocumentTitle, domTitle } from '@/utils/domUtil';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { i18nRender } from '@/locales';
import { notification } from 'ant-design-vue';
import { getRoleByAccount, ROLES } from '@/store/modules/static-router';

NProgress.configure({ showSpinner: false });

const allowList = ['login', 'register', 'registerResult'];
const loginRoutePath = '/user/login';

// 根据角色获取默认路由
const getDefaultRoutePath = (role) => {
  switch (role) {
    case ROLES.ADMIN:
      return '/dashboard';
    case ROLES.CONTENT_MANAGER:
    case ROLES.BLOGGER:
    default:
      return '/content/material';
  }
};

// 获取用户角色
const getUserRole = () => {
  const userInfo = store.getters.userInfo || {};
  // 支持 account 或 email 字段
  const account = userInfo.account || userInfo.email || '';
  return getRoleByAccount(account);
};

// 检查用户是否有权限访问该路由
const hasRoutePermission = (to, userRole) => {
  return to.matched.every((record) => {
    const roles = record.meta?.roles;
    if (!roles || roles.length === 0) {
      return true;
    }
    return roles.includes(userRole);
  });
};

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  to.meta && typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`);

  const token = storage.get(ACCESS_TOKEN);

  if (token) {
    // 处理登录页面和根路径
    if (to.path === loginRoutePath || to.path === '/') {
      const hasRoutes = store.getters.addRouters && store.getters.addRouters.length > 0;

      if (hasRoutes) {
        const role = getUserRole();
        next({ path: getDefaultRoutePath(role) });
        NProgress.done();
      } else {
        try {
          const res = await store.dispatch('GetInfo');

          const role = getUserRole();
          await store.dispatch('GenerateRoutes', { role, ...res });

          resetRouter();
          store.getters.addRouters.forEach((r) => {
            router.addRoute(r);
          });

          router.addRoute({
            path: '*',
            redirect: '/404',
          });

          next({ path: getDefaultRoutePath(role), replace: true });
          NProgress.done();
        } catch (error) {
          console.error('获取用户信息失败:', error);
          notification.error({
            message: '错误',
            description: '请求用户信息失败，请重试',
          });

          await store.dispatch('Logout');
          next({ path: loginRoutePath, replace: true });
          NProgress.done();
        }
      }
    } else {
      // 访问其他页面
      const hasRoutes = store.getters.addRouters && store.getters.addRouters.length > 0;

      if (hasRoutes) {
        const role = getUserRole();

        if (to.matched.length === 0) {
          // 如果路由匹配不到，可能是动态路由还没有添加完成
          // 尝试重新加载路由
          try {
            const res = await store.dispatch('GetInfo');
            await store.dispatch('GenerateRoutes', { role, ...res });

            resetRouter();
            store.getters.addRouters.forEach((r) => {
              router.addRoute(r);
            });

            // 不添加 404 路由，避免拦截动态路由
            next({ ...to, replace: true });
          } catch (error) {
            console.error('重新加载路由失败:', error);
            next({ path: '/404', replace: true });
          }
        } else if (!hasRoutePermission(to, role)) {
          notification.warning({
            message: '权限不足',
            description: '您没有权限访问该页面',
          });
          next({ path: getDefaultRoutePath(role), replace: true });
        } else {
          next();
        }
      } else {
        try {
          const res = await store.dispatch('GetInfo');

          const role = getUserRole();
          await store.dispatch('GenerateRoutes', { role, ...res });

          resetRouter();
          store.getters.addRouters.forEach((r) => {
            router.addRoute(r);
          });

          router.addRoute({
            path: '*',
            redirect: '/404',
          });

          next({ ...to, replace: true });
        } catch (error) {
          console.error('获取用户信息失败:', error);
          notification.error({
            message: '错误',
            description: '请求用户信息失败，请重试',
          });

          await store.dispatch('Logout');
          next({ path: loginRoutePath, query: { redirect: to.fullPath } });
          NProgress.done();
        }
      }
    }
  } else {
    // 未登录
    if (allowList.includes(to.name)) {
      next();
    } else {
      next({ path: loginRoutePath, query: { redirect: to.fullPath } });
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
